import script from "./home-page-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./home-page-button.vue?vue&type=script&setup=true&lang=ts"

import "./home-page-button.vue?vue&type=style&index=0&id=c9f20f54&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9f20f54"]])

export default __exports__